import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbCardModule } from '@nebular/theme';
import { finalize } from 'rxjs/operators';
import {
  SpreadsheetColumnsAssetsService,
  SpreadsheetColumnsInitiativesService,
  SpreadsheetColumnsInvestmentsService
} from '../../../@core/utils';
import { ColDef } from 'ag-grid-community';
import { KPI } from '../../../@core/api';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-pre-download-dialog',
    templateUrl: './pre-download-dialog.component.html',
    styleUrls: ['./pre-download-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    NbCardModule,
    FontAwesomeModule,
    TranslateModule
],
})
export class PreDownloadDialogComponent implements OnInit{

  @Input() public downloadOptions: KPI.TPreExportResp;
  @Input() public columns: ColDef<any, any>[];
  @Input() public reportType: string;

  constructor(
    private ref: NbDialogRef<PreDownloadDialogComponent>,
    private investmentsGridService: SpreadsheetColumnsInvestmentsService,
    private assetsGridService: SpreadsheetColumnsAssetsService,
    private initiativeService: SpreadsheetColumnsInitiativesService
  )
  { }

  ngOnInit(): void {
    if (!!this.reportType) {
      if (this.reportType === 'inv') {
        this.investmentsGridService.exportInvestments(this.columns).pipe(finalize(() => {
          this.ref.close();
        })).subscribe();
      } else if (this.reportType === 'asset') {
        this.assetsGridService.exportAssets(this.columns).pipe(finalize(() => {
          this.ref.close();
        })).subscribe();
      } else if (this.reportType === 'ini') {
        this.initiativeService.exportInitiatives(this.columns).pipe(finalize(() => {
          this.ref.close();
        })).subscribe();
      }
    }
  }

  public close(): void {
    this.ref.close();
  }

}
